import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { IonButton, IonIcon, IonItem, IonLabel } from "@ionic/angular";
import { addIcons } from "ionicons";
import { chatbubbleEllipsesOutline } from "ionicons/icons";

@Component({
  selector: "app-assistant-entry",
  standalone: true,
  imports: [IonButton, IonIcon, IonItem, IonLabel, RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (tile) {
      <ion-button class="shortcut" fill="clear" routerLink="/ask">
        <span><ion-icon name="chatbubble-ellipses-outline" aria-hidden="true" /><small>Ask</small></span>
      </ion-button>
    } @else {
      <ion-item
        routerLink="/ask"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
        [class.menu-entry]="menu"
        button
        detail="false"
        lines="none"
        ><ion-icon slot="start" name="chatbubble-ellipses-outline" aria-hidden="true" /><ion-label
          >Ask assistant</ion-label
        ></ion-item
      >
    }`,
  styles: [
    `
      ion-item {
        --min-height: 48px;
      }
      .menu-entry {
        --padding-start: var(--assistant-entry-padding, 16px);
        --background: transparent;
        --color: var(--ion-color-light);
        font-size: 16px;
      }
      .menu-entry ion-icon {
        color: inherit;
        font-size: 20px;
        margin-inline-end: 10px;
      }
      .menu-entry.active {
        --color: var(--ion-color-success);
      }
      .shortcut {
        width: 100%;
        height: 100%;
        min-height: 60px;
        margin: 0;
        --padding-start: 0;
        --padding-end: 0;
        --padding-top: 10px;
        --padding-bottom: 10px;
        --border-radius: 4px;
        --background: var(--ion-color-primary);
        --color: var(--ion-color-light);
      }
      .shortcut span {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
      }
      .shortcut ion-icon {
        font-size: 26px;
      }
      .shortcut small {
        font-size: 12px;
        text-transform: none;
        line-height: 1.1;
      }
    `,
  ],
})
export class AssistantEntry {
  @Input() menu = false;
  @Input() tile = false;
  constructor() {
    addIcons({ chatbubbleEllipsesOutline });
  }
}
